// Base URLの差し替えなどを行うため、fetch関数をglobalにinterceptする
//
// TrackManager系のAPIに関してはaxiosではなくfetchを使っているため
// fetch用の設定も残す必要がある
const apiBaseUrl = import.meta.env.VITE_API_URL;
if (!apiBaseUrl) {
  throw new Error("VITE_API_URL is not defined");
}

const originalFetch = window.fetch;
const interceptFetch: typeof fetch = async (
  input: string | URL | globalThis.Request,
  init?: RequestInit,
): Promise<Response> => {
  console.log("[interceptFetch]", { input, init });

  // orval生成コードはURLをstringで渡してくるため、inputがstringでない場合エラー
  if (typeof input !== "string") {
    throw new Error(
      "[interceptFetch] fetch関数のinputはstring型である必要があります",
    );
  }
  try {
    const url = new URL(input, apiBaseUrl);
    return await originalFetch(url, init);
  } catch (error) {
    // エラーハンドリング
    console.error("Fetch error:", error);
    throw error;
  }
};
window.fetch = interceptFetch;
